import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, onChange, testId = "stars" }) => (
  <span data-testid={testId} className="inline-flex items-center gap-0.5" role={onChange ? "radiogroup" : undefined}>
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= Math.round(value);
      const star = <Star size={size} className={filled ? "fill-[#ff2a85] text-[#ff2a85]" : "text-[#d5d4ce]"} strokeWidth={1.8} />;
      return onChange ? (
        <button key={n} type="button" data-testid={`${testId}-${n}`} aria-label={`${n} star${n > 1 ? "s" : ""}`} onClick={() => onChange(n)} className="p-0.5 transition-transform hover:scale-110">
          {star}
        </button>
      ) : (
        <span key={n}>{star}</span>
      );
    })}
  </span>
);
